module.exports = {
  project_name: "ulsemo",
  project_server_location: "europe-west1",
}
